import React, { useEffect, useState } from "react";
// Components
import FiltersList from "../FiltersList";
import HeaderBar from "./components/HeaderBar";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
// types
import { FiltersProps } from "./types";
import { IfetchDynamicForms } from "store/dynamicForms/initialState";
import { DynamicFormsColumnModal } from "view/components/Modals/Forms/DynamicFormsColumnModal";
import { isAnyDynamicFormFilterApplied } from "../AppliedFilters";
import { filtersInitialState } from "store/filters/initialState";
import { getFiltersDataFromLocalStorage } from "utils/cacheOrRetriveFiltersDate";

export const Filters: React.FC<FiltersProps> = ({ columns }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCloseDiv, setIsCloseDiv] = useState(false);
  const { data } = useSelector<RootState, IfetchDynamicForms>(
    (state) => state?.allforms
  );

  const { dynamicFormsFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );

  // Handlers
  const handleToggleDropdown = () => {
    setIsCloseDiv((prevState) => !prevState);
  };



  useEffect(() => {
    const filtersData = getFiltersDataFromLocalStorage();
    setIsCloseDiv((pre: any) => {
      if (filtersData !== undefined) {
        return isAnyDynamicFormFilterApplied(filtersData.filters);
      } else {
        return isAnyDynamicFormFilterApplied(dynamicFormsFilter);
      }
    });
  }, []);
  return (
    <>
      <div className="flex flex-col items-start justify-start w-full gap-2">
        <HeaderBar
          data={data}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          handleToggleDropdown={handleToggleDropdown}
          isCloseDiv={isCloseDiv}
        />
        <FiltersList isCloseDiv={isCloseDiv} />
      </div>
      {isOpen && (
        <DynamicFormsColumnModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          columns={columns.filter((item: any) => item.id !== "select")}
        />
      )}
    </>
  );
};
